import React, { useEffect, useState } from 'react';
import { AdminBusinessUser, AdminProviderListUser, LeanUserWithPhone } from 'models';
import { IconButton } from 'library';
import { Message } from '@mui/icons-material';
import OutreachConversationModal from 'internal/texting/outreach/OutreachConversationModal';
import { TANDEM_NUMBERS } from 'internal/texting/outreach/OutreachModels';

export default function ProviderExternalMessaging({
    user,
    messages,
    iconSize,
}: {
    user: LeanUserWithPhone | AdminBusinessUser | AdminProviderListUser;
    messages?: string[];
    iconSize?: number;
}) {
    const [messagesOpen, setMessagesOpen] = useState(false);

    useEffect(() => {
        if (messages && messages.length > 0) {
            setMessagesOpen(true);
        }
    }, [messages]);

    return (
        <>
            <span style={{ marginLeft: 10 }}>
                <IconButton
                    tooltip="Message worker"
                    icon={Message}
                    onClick={() => {
                        setMessagesOpen(true);
                    }}
                    size={iconSize}
                />
            </span>
            <OutreachConversationModal
                externalNumber={user.phone_number}
                tandemNumber={TANDEM_NUMBERS.PROVIDER_SUCCESS_FUNNEL}
                displayName={`${user.first_name} ${user.last_name}`}
                isOpen={messagesOpen}
                onClose={() => setMessagesOpen(false)}
                provider={{ user: user }}
            />
        </>
    );
}
